module.exports = __webpack_public_path__ + "static/media/planeta.7876d4f2.png";